import React, { useState, useEffect } from "react"; // Added useEffect
import { lang } from "../lang";

function NotesModal({ isOpen, notes, onSave, onCancel }) {
  const [noteText, setNoteText] = useState(notes);

  // Update internal state if the notes prop changes (e.g., opening modal for a different task)
  useEffect(() => {
    setNoteText(notes);
  }, [notes, isOpen]); // Also update if isOpen changes, to reset text when re-opened for same task after closing

  const handleSave = () => {
    if (process.env.NODE_ENV === "development") {
      console.log("Saving notes:", noteText);
    }
    onSave(noteText);
  };

  if (!isOpen) return null;

  const notesModalLang = lang?.notesModal || {};
  const title = notesModalLang.title || "Edit Notes";
  const saveText = notesModalLang.save || "Save";
  const cancelText = notesModalLang.cancel || "Cancel";

  return (
    <div className="modal">
      <div className="modal-content">
        <h3 className="modal-title">{title}</h3>
        <textarea
          value={noteText}
          onChange={(e) => setNoteText(e.target.value)}
          className="modal-textarea"
        />
        <div className="modal-actions">
          <button onClick={onCancel} className="button-cancel">
            {cancelText}
          </button>
          <button onClick={handleSave} className="button-save">
            {saveText}
          </button>
        </div>
      </div>
    </div>
  );
}

export default NotesModal;
